import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '../app.auth_guard';
import { Shopify2SetupComponent } from '../shopify/shopify2-setup/shopify2-setup.component';
import { RoleGuard } from '../role-guard.guard';

const shopifyRoutes: Routes = [
  {
    path: 'shopify2-setup',
    component: Shopify2SetupComponent,
    canActivate: [AuthGuard, RoleGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(shopifyRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class ShopifyRoutingModule {}
